
export default {
  namespaced: true,
  state: {
    searchKeyword: '',
    fileList: [],
    uploadImg: '',
    longitude: '', // 经度
    latitude: '', // 纬度
    provinceName: '', // 省
    provinceCode: '', // 省编码
    cityName: '', // 市
    cityCode: '', // 市编码
    areaName: '', // 区
    areaCode: '', // 区编码
    showItemMuName: '数据大屏'
  },
  getters: {},
  mutations: {
    changeShowItemMuName (state, payload) {
      console.log(payload)
      state.showItemMuName = payload
    },
    changeSearchKeyword (state, payload) {
      state.searchKeyword = payload
    },
    changeFileList (state, payload) {
      state.fileList = payload
    },
    changeUploadImg (state, payload) {
      state.uploadImg = payload
    },
    changeLatitudeAndLongitude (state, payload) {
      state.latitude = payload.latitude
      state.longitude = payload.longitude
    },
    changeProvince (state, payload) {
      state.provinceCode = payload.provinceCode
      state.provinceName = payload.provinceName
      state.cityCode = payload.cityCode
      state.cityName = payload.cityName
      state.areaCode = payload.areaCode
      state.areaName = payload.areaName
    }
  },
  actions: {}
}
